export const DEFAULT_SLACK_SERVICE_URL = '/gateway/api/slack';
export const SOURCE = 'invite-people';

export const CLIENT_ERROR_STATUS = 0;
export const CLIENT_ERROR_CODE = 'NETWORK_ERROR';
export const CLIENT_ERROR_MESSAGE = 'Network error';

export const CONFLUENCE_METADATA_ERROR = 'CONFLUENCE_METADATA_ERROR';

export const ANALYTICS_CHANNEL = 'peopleTeams';

export const WINDOW_WIDTH = 480;
export const WINDOW_HEIGHT = 924;

export const DEFAULT_STARGATE_SERVICE_URL = '/gateway/api';
export const EXUS_THIRDPARTY_PATH = '/external-users/third-party';
export const EXUS_ORGS_PATH = '/external-users/orgs';
export const INTEGRATIONS_PATH = 'integrations';
export const SEARCH_ACTION = 'Third Party Search';
export const ORG_SETTINGS_ACTION = 'Organisation Settings';
export const ITPT_PATH = '/growth/invite-3rd-party-teams';
export const ITPT_SLACK_CHANNELS = '/slack-channels';

export const GOOGLE_SERVICE = 'google-invites';
export const MICROSOFT_SERVICE = 'microsoft-invites';

export const INTEGRATIONS_FETCH_RETRIES_COUNT = 3;
